'use client'

import { useEffect, useState } from 'react'
import styles from './ua.module.scss'
import { searchInventory } from '@/data/Inventory'
import { logError } from '@/utils/LoggingUtil'
import Tiles from '@/components/tile/Tiles'
import InventoryTile from '../vehicles/InventoryTile'
import { strings } from '@/utils/I18n'
import { isDesktop, isMobile } from 'react-device-detect'

export default function Recommendations(props) {

  const site = props.site
  const params = props.params
  const mobile = props.mobile
  const desktop = props.desktop
  const size = props.size
  const [list, setList] = useState()

  useEffect(() => {
    if ((isMobile || isDesktop) && ((isMobile && mobile) || (isDesktop && !mobile))) {
      setTimeout(() => {
        searchInventory(site, Object.assign({}, params, { cache: true })).then(data => {
          if (size) {
            setList(data.results.slice(0, size))
          } else {
            setList(data.results)
          }
        }).catch(err => {
          logError(err)
        })
      }, 1000)
    }
  }, [])

  if (!list || list.length == 0) return <></>

  return <section>
    <section>
      <h2 className={ styles.h + ' ' + styles.h2 }>{ strings(site)['vdp_recommendedVehicles'] }</h2>
    </section>
    <section>
      <Tiles padded={true}>
        { list.map((item,index) => (
          <InventoryTile key={index} index={index} {...props} budget={props.budget} item={item}></InventoryTile>
        ))}
      </Tiles>
    </section>
    <section></section>
    <section></section>
  </section>

}